// Step Functions state-type colours shared by the graph nodes, minimap and
// legend. State hues are categorical mid-tones that read on both themes; the
// neutral and status entries follow the --if-* layer.
export const TYPE_COLORS = {
  task: '#11BC6E',
  choice: '#4A90D9',
  parallel: '#8B5CF6',
  map: '#6366F1',
  pass: 'var(--if-border-strong)',
  wait: '#F5A623',
  succeed: '#0A8F4F',
  fail: '#DE322F',
};

export const START_END_COLOR = 'var(--if-ink-1)';

export const EXEC_STATUS_COLORS = {
  RUNNING: 'var(--if-info)',
  SUCCEEDED: 'var(--if-success)',
  FAILED: 'var(--if-danger)',
};

export const typeColor = (type, fallback = TYPE_COLORS.pass) =>
  TYPE_COLORS[String(type || '').replace(/^sfn-/, '')] || fallback;
